import { Controller } from "@hotwired/stimulus";
import { useListen } from "hb/insights/use_listen";

export default class extends Controller {
  static outlets = ["searchable-list"]

  connect() {
    useListen(this);

    // Listen for Bootstrap dropdown events
    const dropdown = this.element.querySelector('.dropdown')
    if (dropdown) {
      dropdown.addEventListener('shown.bs.dropdown', this.onDropdownShown.bind(this))
    }

    this.listenWindow("dashboard:openAddWidget", this.show);
  }

  disconnect() {
    const dropdown = this.element.querySelector('.dropdown')
    if (dropdown) {
      dropdown.removeEventListener('shown.bs.dropdown', this.onDropdownShown.bind(this))
    }
  }

  onDropdownShown() {
    // Focus the search input when dropdown is revealed
    if (this.searchableListOutlet) {
      this.searchableListOutlet.focus()
    }
  }

  show() {
    // Trigger the Bootstrap dropdown programmatically
    const dropdownToggle = this.element.querySelector('[data-bs-toggle="dropdown"]')
    if (dropdownToggle) {
      dropdownToggle.click()
    }
  }

  handleSelection(event) {
    const { data } = event.detail;
    const widgetData = data.widgetConfig ? JSON.parse(data.widgetConfig) : null;
    this.emitWindow('dashboard:addWidget', widgetData);

    // Close the dropdown
    const dropdownToggle = this.element.querySelector('[data-bs-toggle="dropdown"]')
    if (dropdownToggle) {
      const dropdown = window.bootstrap.Dropdown.getInstance(dropdownToggle)
      if (dropdown) {
        dropdown.hide()
      }
    }
  }
}
